<template>
  <ul class="menu nav-submenu submenu is-dropdown-submenu first-sub vertical"
      data-submenu
      role="menubar">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'NavigationItemSubmenu'
};
</script>
